<template>
  <div class="animated fadeIn">
      <div class="p-0">
        <div v-if="loading" class="loading-container">
          <RotateSquare
            class="loading-position animated fadeIn"
            size="60px"
          ></RotateSquare>
        </div>
        <iframe
          v-else-if="url"
          :src="url"
          class="geoportal-frame"
          title="GeoPortal"
        ></iframe>
        <p v-else class="text-center text-muted m-4">
          Não foi possível carregar o Geo Portal.
        </p>
      </div>
  </div>
</template>

<script>
import ParametroServico from "../../servico/ParametroServico";
import RotateSquare from "../../components/RotateSquare";

export default {
  name: "GeoPortal",
  components: {
    RotateSquare
  },
  data() {
    return {
      loading: false,
      url: ""
    };
  },
  mounted() {
    this.ObterUrl();
  },
  methods: {
    ObterUrl() {
      this.loading = true;
      ParametroServico.GetGeoPortal()
        .then((response) => {
          this.loading = false;
          this.url = response.data;
        })
        .catch((erro) => {
          this.loading = false;
          const data = erro.response && erro.response.data;
          this.$notify({
            data: (data && data.erros) || [
              data || "Erro ao obter a URL do GeoPortal."
            ],
            type: "warn",
            duration: 5000
          });
        });
    }
  }
};
</script>

<style scoped>
.geoportal-frame {
  display: block;
  width: 100%;
  height: calc(100vh - 220px);
  min-height: 500px;
  border: 0;
}
</style>
